import styled from 'styled-components'

export default styled.div`
  background: #F3F6F7;
  border-right: 1px solid #E7EAEE;
  padding: 10px;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/Sidebar.js